import {schema} from "normalizr"

/**
 * Order lines schemas.
 */
export const refunds = new schema.Entity("refunds")
export const arrayOfRefunds = [refunds]
